<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            pr: {
                prNumber: "",
                id: 0,
            },
        };
    },
    methods: {
        getPR(row){
            this.pr = {
                prNumber: row.prNumber,
                id: row.id,
            };
        },
        changeNumber() {
            Swal.fire({
                title: "Are you sure?",
                text: `You want to update the pr number?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, update it!",
            }).then((result) => {
                if(!result.value){
                    return;
                }
                this.$store
                    .dispatch("pr/UpdatePRNo", {
                        id: this.pr.id,
                        body: this.pr.prNumber
                    })
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.$emit('prNumberChanged', this.pr.prNumber);
                        this.showToast("Successfully changed", "success");
                        this.$bvModal.hide("pr-number-modal");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            });
        },
    },
}
</script>
<template>
    <b-modal
        id="pr-number-modal"
        title="Change PR Number"
        size="sm"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="changeNumber">
            <div class="p-3">
                <b-form-group label="PR Number" label-for="pr-number">
                    <b-form-input
                        id="pr-number"
                        v-model="pr.prNumber"
                        placeholder="Enter PR Number"
                        required
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="modal-footer">
                <button 
                    type="submit"
                    class="btn btn-primary"
                >Set New PR No.</button>
                <button 
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('pr-number-modal')"
                >Cancel</button>
            </div>
        </form>
    </b-modal>
</template>